import { PARTNER360_NAMESPACE } from '../common/constants'

export const PARTNER360_JBP_SETTINGS_NAMESPACE = `${PARTNER360_NAMESPACE}/jbpSettings`

// Async thunk constants
export const REQUEST_JBP_SETTINGS = `${PARTNER360_JBP_SETTINGS_NAMESPACE}/requestJBPSettings`
